/*
 *
 *  *
 *  *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  *  Crompton R&D IoT Department Proprietary Software
 *  *
 *  *  This file is part of Crompton Smart Home SDK
 *  *  Copyright (c) 2025 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *  *
 *  *  This software, including documentation, is protected by copyright by
 *  *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  *  adapting or translating, any or all of this material requires the prior written consent of
 *  *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *  *
 *  *  Filename :
 *  *  * Created on: <Date>
 *  *  Author    :
 *  *  * #endregion
 *  * /
 *  *
 *
 */

// import React, {useEffect, useState} from "react";
// import Banner from "./recipeComponents/Banner";
// import ClipLoader from "react-spinners/ClipLoader";
// import {useUserAuth} from "../../../context/UserAuthContext";
// import {AES, enc} from "crypto-js";
// import axios from "axios";
// import RecipeList from "./recipeComponents/RecipeList";
// import {useNavigate} from "react-router-dom";
//
// const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
//
// const Recipe = () => {
//
//     const secretKey = "cromptonssecretkey";
//     let {Token, logOut, accesscontrollevel} = useUserAuth();
//     const navigate = useNavigate();
//     const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
//
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//
//     const handleLogOut = async () => {
//         try {
//             await logOut();
//             navigate("/");
//         } catch (error) {
//             ////console.log(error.message);
//         }
//     }
//
//     const getRecipeData = async () => {
//         try {
//             var url = CROMPTON_URL + "recipes/all";
//             const response = await axios.get((url), {
//                 headers: {
//                     Authorization: decryptedValue
//                 }
//             });
//             if (response.status === 200) {
//                 if (response.data.recipes.length !== 0 && response.data.totalRecipes !== 0) {
//                     sessionStorage.setItem("AllRecipe", JSON.stringify(response.data.recipes));
//                     setIsLoading(false);
//                     setData(response.data.recipes);
//                 }
//             } else {
//                 setIsLoading(false);
//                 // console.log(response);
//             }
//         } catch (error) {
//             if (error.response.data.status === "401" || error.response.data.status === "403") {
//                 handleLogOut();
//             }else{
//                 console.log(error.response.data);
//             }
//         }
//     }
//
//     useEffect(() => {
//         const recipeData = JSON.parse(sessionStorage.getItem("AllRecipe"));
//         if (recipeData === "" || recipeData === null) {
//             getRecipeData();
//             // console.log("API CALLED.")
//         } else {
//             setData(recipeData);
//             setIsLoading(false);
//             // console.log("API NOT CALLED");
//         }
//     }, []);
//
//     return (
//         <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">
//             <Banner/>
//
//             {isLoading === true ? (
//                 <div className="flex justify-center items-center h-64">
//                     <ClipLoader color="#2563eb" size={50}/>
//                 </div>
//
//             ) : (
//                 <div className="mt-5 dark:bg-navy-900">
//                     <RecipeList
//                         recipes={data}
//                     />
//                 </div>
//             )}
//         </div>
//     )
// }
// export default Recipe;
//

// import React, {useEffect, useState} from "react";
// import Banner from "./recipeComponents/Banner";
// import ClipLoader from "react-spinners/ClipLoader";
// // import {useUserAuth} from "../../../context/UserAuthContext";
// // import {AES, enc} from "crypto-js";
// // import axios from "axios";
// import RecipeList from "./recipeComponents/RecipeList";
// // import {useNavigate} from "react-router-dom";
//
// // const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
//
// const Recipe = () => {
//
//     // const secretKey = "cromptonssecretkey";
//     // let {Token, logOut, accesscontrollevel} = useUserAuth();
//     // const navigate = useNavigate();
//     // const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
//
//     // const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//
//     // ✅ Lifted state: track if a recipe is selected
//     const [isRecipeDetailOpen, setIsRecipeDetailOpen] = useState(false);
//
//     // const handleLogOut = async () => {
//     //     try {
//     //         await logOut();
//     //         navigate("/");
//     //     } catch (error) {
//     //         // console.log(error.message);
//     //     }
//     // }
//     //
//     // const getRecipeData = async () => {
//     //     try {
//     //         var url = CROMPTON_URL + "recipes/all";
//     //         const response = await axios.get((url), {
//     //             headers: {
//     //                 Authorization: decryptedValue
//     //             }
//     //         });
//     //         if (response.status === 200) {
//     //             if (response.data.recipes.length !== 0 && response.data.totalRecipes !== 0) {
//     //                 sessionStorage.setItem("AllRecipe", JSON.stringify(response.data.recipes));
//     //                 setIsLoading(false);
//     //                 setData(response.data.recipes);
//     //             }
//     //         } else {
//     //             setIsLoading(false);
//     //         }
//     //     } catch (error) {
//     //         if (error.response.data.status === "401" || error.response.data.status === "403") {
//     //             handleLogOut();
//     //         } else {
//     //             console.log(error.response.data);
//     //         }
//     //     }
//     // }
//     //
//     // useEffect(() => {
//     //     const recipeData = JSON.parse(sessionStorage.getItem("AllRecipe"));
//     //     if (recipeData === "" || recipeData === null) {
//     //         getRecipeData();
//     //     } else {
//     //         setData(recipeData);
//     //         setIsLoading(false);
//     //     }
//     // }, []);
//
//     return (
//         <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">
//
//             {/* ✅ Hide Banner when recipe detail is open */}
//             {!isRecipeDetailOpen && <Banner />}
//
//             {isLoading === true ? (
//                 <div className="flex justify-center items-center h-64">
//                     <ClipLoader color="#2563eb" size={50}/>
//                 </div>
//             ) : (
//                 <div className="mt-5 dark:bg-navy-900">
//                     <RecipeList
//                         // recipes={data}
//                         // ✅ Pass the callback down to RecipeList
//                         onRecipeDetailToggle={setIsRecipeDetailOpen}
//                     />
//                 </div>
//             )}
//         </div>
//     )
// }
//
// export default Recipe;

// import React, { useState, useEffect } from 'react';
// import RecipeList from './recipeComponents/RecipeList';
// import { useUserAuth } from "../../../context/UserAuthContext";
// import { AES, enc } from 'crypto-js';
//
// const Recipe = () => {
//     const [allRecipes, setAllRecipes] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [decryptedToken, setDecryptedToken] = useState(null);
//     const [isRecipeDetailOpen, setIsRecipeDetailOpen] = useState(false);
//
//     const { Token } = useUserAuth();
//     const API_BASE_URL = process.env.REACT_APP_CROMPTON_SENZE_RECIPE_URL;
//     const secretKey = "cromptonssecretkey";
//
//     // ✅ Decrypt token on component mount or when Token changes
//     useEffect(() => {
//         if (Token) {
//             try {
//                 const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
//                 setDecryptedToken(decryptedValue);
//             } catch (error) {
//                 console.error('Error decrypting token:', error);
//                 setDecryptedToken(null);
//             }
//         } else {
//             setDecryptedToken(null);
//         }
//     }, [Token]);
//
//     // ✅ Check sessionStorage and fetch recipes when token is ready
//     useEffect(() => {
//         if (decryptedToken) {
//             checkAndFetchRecipes();
//         }
//     }, [decryptedToken]);
//
//     // ✅ Check if recipes exist in sessionStorage, if not fetch from API
//     const checkAndFetchRecipes = () => {
//         try {
//             const storedRecipes = sessionStorage.getItem('AllRecipes');
//
//             if (storedRecipes) {
//                 // ✅ Data exists in sessionStorage, use it
//                 console.log('📦 Loading recipes from sessionStorage');
//                 const parsedRecipes = JSON.parse(storedRecipes);
//                 setAllRecipes(parsedRecipes);
//                 setLoading(false);
//             } else {
//                 // ✅ No data in sessionStorage, fetch from API
//                 console.log('🌐 No data in sessionStorage, fetching from API');
//                 fetchAllRecipes();
//             }
//         } catch (error) {
//             console.error('Error reading from sessionStorage:', error);
//             // If there's an error reading cache, fetch from API
//             fetchAllRecipes();
//         }
//     };
//
//     // ✅ Fetch recipes from /recipes/V2/all API
//     const fetchAllRecipes = async () => {
//         console.log('🌐 Fetching fresh recipes from /recipes/V2/all API');
//         setLoading(true);
//         setError(null);
//
//         try {
//             const response = await fetch(`${API_BASE_URL}recipes/V2/all`, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': decryptedToken,
//                     'Content-Type': 'application/json',
//                 },
//             });
//
//             if (!response.ok) {
//                 throw new Error(`API error! status: ${response.status}`);
//             }
//
//             const data = await response.json();
//
//             if (data.success && data.recipes && Array.isArray(data.recipes)) {
//                 console.log(`✅ Fetched ${data.recipes.length} recipes from API`);
//
//                 // ✅ Store the entire response
//                 setAllRecipes(data);
//
//                 // ✅ Save to sessionStorage
//                 try {
//                     sessionStorage.setItem('AllRecipes', JSON.stringify(data));
//                     console.log('💾 Recipes saved to sessionStorage');
//                 } catch (storageError) {
//                     console.error('Error saving to sessionStorage:', storageError);
//                 }
//             } else {
//                 throw new Error(data.message || 'Failed to fetch recipes');
//             }
//         } catch (error) {
//             console.error('Error fetching recipes:', error);
//             setError(error.message);
//
//             // ✅ On error, try to load from sessionStorage as fallback
//             try {
//                 const storedRecipes = sessionStorage.getItem('AllRecipes');
//                 if (storedRecipes) {
//                     console.log('⚠️ API failed, loading from sessionStorage as fallback');
//                     setAllRecipes(JSON.parse(storedRecipes));
//                     setError(null); // Clear error since we have cached data
//                 }
//             } catch (fallbackError) {
//                 console.error('Error reading fallback from sessionStorage:', fallbackError);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     // ✅ Handle refresh from child component
//     const handleRefresh = () => {
//         // Clear sessionStorage and fetch fresh data
//         try {
//             sessionStorage.removeItem('AllRecipes');
//             console.log('🗑️ Cleared sessionStorage');
//         } catch (error) {
//             console.error('Error clearing sessionStorage:', error);
//         }
//         fetchAllRecipes();
//     };
//
//     // ✅ Handle recipe detail toggle
//     const handleRecipeDetailToggle = (isOpen) => {
//         setIsRecipeDetailOpen(isOpen);
//     };
//
//     return (
//         <div className="mt-5 grid h-full w-full gap-5">
//             <RecipeList
//                 onRecipeDetailToggle={handleRecipeDetailToggle}
//                 AllRecipe={allRecipes}
//                 onRefresh={handleRefresh}
//                 isLoading={loading}
//                 error={error}
//             />
//         </div>
//     );
// };
//
// export default Recipe;

import React, { useState, useEffect } from 'react';
import Banner from "./recipeComponents/Banner";
import RecipeList from './recipeComponents/RecipeList';
import { useUserAuth } from "../../../context/UserAuthContext";
import { AES, enc } from 'crypto-js';

const Recipe = () => {
    const [allRecipes, setAllRecipes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [decryptedToken, setDecryptedToken] = useState(null);
    const [isRecipeDetailOpen, setIsRecipeDetailOpen] = useState(false);

    const { Token } = useUserAuth();
    const API_BASE_URL = process.env.REACT_APP_CROMPTON_SENZE_RECIPE_URL;
    const secretKey = "cromptonssecretkey";

    // ✅ Decrypt token on component mount or when Token changes
    useEffect(() => {
        if (Token) {
            try {
                const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
                setDecryptedToken(decryptedValue);
            } catch (error) {
                console.error('Error decrypting token:', error);
                setDecryptedToken(null);
            }
        } else {
            setDecryptedToken(null);
        }
    }, [Token]);

    // ✅ Check sessionStorage and fetch recipes when token is ready
    useEffect(() => {
        if (decryptedToken) {
            checkAndFetchRecipes();
        }
    }, [decryptedToken]);

    // ✅ Check if recipes exist in sessionStorage, if not fetch from API
    const checkAndFetchRecipes = () => {
        try {
            const storedRecipes = sessionStorage.getItem('AllRecipes');

            if (storedRecipes) {
                // ✅ Data exists in sessionStorage, use it
                console.log('📦 Loading recipes from sessionStorage');
                const parsedRecipes = JSON.parse(storedRecipes);
                setAllRecipes(parsedRecipes);
                setLoading(false);
            } else {
                // ✅ No data in sessionStorage, fetch from API
                console.log('🌐 No data in sessionStorage, fetching from API');
                fetchAllRecipes();
            }
        } catch (error) {
            console.error('Error reading from sessionStorage:', error);
            // If there's an error reading cache, fetch from API
            fetchAllRecipes();
        }
    };

    // ✅ Fetch recipes from /recipes/V2/all API
    const fetchAllRecipes = async () => {
        console.log('🌐 Fetching fresh recipes from /recipes/V2/all API');
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_BASE_URL}recipes/V2/all`, {
                method: 'GET',
                headers: {
                    'Authorization': decryptedToken,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`API error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success && data.recipes && Array.isArray(data.recipes)) {
                console.log(`✅ Fetched ${data.recipes.length} recipes from API`);

                // ✅ Store the entire response
                setAllRecipes(data);

                // ✅ Save to sessionStorage
                try {
                    sessionStorage.setItem('AllRecipes', JSON.stringify(data));
                    console.log('💾 Recipes saved to sessionStorage');
                } catch (storageError) {
                    console.error('Error saving to sessionStorage:', storageError);
                }
            } else {
                throw new Error(data.message || 'Failed to fetch recipes');
            }
        } catch (error) {
            console.error('Error fetching recipes:', error);
            setError(error.message);

            // ✅ On error, try to load from sessionStorage as fallback
            try {
                const storedRecipes = sessionStorage.getItem('AllRecipes');
                if (storedRecipes) {
                    console.log('⚠️ API failed, loading from sessionStorage as fallback');
                    setAllRecipes(JSON.parse(storedRecipes));
                    setError(null); // Clear error since we have cached data
                }
            } catch (fallbackError) {
                console.error('Error reading fallback from sessionStorage:', fallbackError);
            }
        } finally {
            setLoading(false);
        }
    };

    // ✅ Handle refresh from child component
    const handleRefresh = () => {
        // Clear sessionStorage and fetch fresh data
        try {
            sessionStorage.removeItem('AllRecipes');
            console.log('🗑️ Cleared sessionStorage');
        } catch (error) {
            console.error('Error clearing sessionStorage:', error);
        }
        fetchAllRecipes();
    };

    // ✅ Handle recipe detail toggle
    const handleRecipeDetailToggle = (isOpen) => {
        setIsRecipeDetailOpen(isOpen);
    };

    return (
        <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">

            {/* ✅ Hide Banner when recipe detail is open */}
            {!isRecipeDetailOpen && <Banner />}

            {/* ✅ Loading State */}
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#004c86] dark:border-white"></div>
                </div>
            ) : (
                <div className="mt-5 dark:bg-navy-900">
                    <RecipeList
                        onRecipeDetailToggle={handleRecipeDetailToggle}
                        AllRecipe={allRecipes}
                        onRefresh={handleRefresh}
                        isLoading={loading}
                        error={error}
                    />
                </div>
            )}
        </div>
    );
};

export default Recipe;